export default {
  SET_ROLE(state, data) {
    state.role = data
  },
  SET_ROLE_LIST(state, data) {
    state.roleList = data
  },
}
